import React from 'react'
import styled from 'styled-components';
import SliderComp from './Slider';

const Blogs = () => {
    return (
        <Container id='blog'>
            <h1><span className="green">Blogs</span></h1>
            <p>It's a testament to my passion for learning, sharing knowledge, and contributing to the professional community. 
                It serves as a valuable resource for individuals seeking industry insights, practical advice, 
                and thought-provoking content, while also highlighting my skills as a writer and thought leader 
                within my field.</p>
            <SliderComp />
        </Container>
    )
}

export default Blogs;

const Container = styled.div`
    width: 80%;
    margin: 0 auto;
    padding: 3rem 0;
    text-align: center;
    position: relative;
    @media(max-width: 60%){
        width: 90%;
    }
    h1{
        font-size: 1.9rem;
    }

    p{
        width: 65%;
        margin: 0 auto;
        padding: 1rem 0;
        font-size: 0.9rem;
        @media(max-width : 500px){
            width: 90%;
        }
    }
    
`